import { render } from "./new_vehicle_form.vue?vue&type=template&id=488d5d94&scoped=true"
import script from "./new_vehicle_form.vue?vue&type=script&lang=js"
export * from "./new_vehicle_form.vue?vue&type=script&lang=js"

import "./new_vehicle_form.vue?vue&type=style&index=0&id=488d5d94&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-488d5d94"]])

export default __exports__